import {combineReducers} from '@modifi/redux'
import {EntityState} from '@modifi/redux/lib/esm/factories/entity/reducer'
import {CurrencyConfigurationView} from '@modifi/onboarding-api-clients'
import entityReducer from './entity'
import collectionReducer from './collection'

export default combineReducers({
  entity: entityReducer,
  collection: collectionReducer,
})

// @ts-expect-error to be fixed
export type CurrencyState = EntityState<CurrencyConfigurationView>
